module.exports = __webpack_public_path__ + "static/media/landingxxhdpi.8a2f8154.png";